import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useParams } from 'react-router-dom';

import CustomDropdown from '@components/CustomDropdown';
import { toastError, toastSuccess } from '@components/Toast';

import ApiClient from '@lib/apiClient';

import { packTag, setTag, STATIC_SET_CONSTANTS } from '@utils/Util';

const CreateNewPi = ({ onCloseModal, rfqIdList, type }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [taggedList, setTaggedList] = useState([]);
	const [allInvoiceList, setAllInvoiceList] = useState([]);
	const [errors, setErrors] = useState('');
	const [selectedPi, setSelectedPi] = useState(null);
	const { id } = useParams();

	const onGetList = async () => {
		setIsLoading(true);
		await ApiClient.GET('invoiceAction', `tagged-status/order/${id}?rfqIds=${rfqIdList}`)
			.then(({ data }) => {
				setIsLoading(false);
				setTaggedList(data);
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Something went wrong! Please try again.');
				}
			});
	};

	const onFetchInvoiceList = async () => {
		setIsLoading(true);
		await ApiClient.GET('getProjectInvoice', `${id}/all`)
			.then(({ data }) => {
				setIsLoading(false);
				let list = data.map((item) => ({
					id: item.id,
					value: `${item.invoiceNumber} • ${item?.totalQuantity} Pcs • $${parseFloat(
						item?.totalAmount
					).toFixed(2)}`
				}));
				setAllInvoiceList(list);
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Something went wrong! Please try again.');
				}
			});
	};

	useEffect(() => {
		onGetList();
		if (type === 'ADD') {
			onFetchInvoiceList();
		}
	}, []);

	const onItemClick = (item) => {
		setSelectedPi(item);
	};

	const onSubmit = async () => {
		let sortedRfqIds = taggedList?.filter((item) => !item?.isTaggedWithPI)?.map((item) => item.rfqId);
		if (type === 'ADD' && !selectedPi) {
			setErrors('PI selection required');
			return;
		}
		setIsLoading(true);
		let url =
			type === 'ADD'
				? `${selectedPi?.id}/add-product?rfqIds=${sortedRfqIds}`
				: `order/${id}/create?rfqIds=${sortedRfqIds}`;
		await ApiClient.POST('invoiceAction', {}, url)
			.then(({ data }) => {
				setIsLoading(false);
				toastSuccess(data?.message || 'Added');
				onCloseModal();
				setErrors('');
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Something went wrong! Please try again.');
				}
			});
	};

	const isDisabled = () => taggedList.every((item) => item?.isTaggedWithPI);

	return (
		<div>
			<Modal show={true} onHide={onCloseModal} backdrop="static" className="create-or-add-pi" centered>
				<div className="common-popup">
					<div className="common-popup-header d-flex justify-content-between">
						<div className="popup-tilte">
							<h3 className="semibold-16 mb-0">
								{type === 'ADD' ? 'Add to PI' : 'Create new PI'}
							</h3>
						</div>
						<div className="close-btn">
							<img
								src={`${process.env.PUBLIC_URL}/icons/close.svg`}
								alt="close"
								onClick={onCloseModal}
							/>
						</div>
					</div>
					<div className="common-popup-body">
						<div className="sample-details-table">
							{type === 'ADD' && (
								<div className="single-filter select-pi-number">
									<CustomDropdown
										title={'Select PI number to add style'}
										type="addItem"
										onItemClick={onItemClick}
										items={allInvoiceList}
										selectedItem={selectedPi?.value}
									/>
									<span className="red pl-1 pt-1">{errors}</span>
								</div>
							)}
							<table className="table with-border mb-0">
								<thead>
									<tr>
										<th className="design-details-column">
											Designs({taggedList.length})
										</th>
										<th className="date-column">PO number</th>
										<th className="date-column">PI Status</th>
									</tr>
								</thead>
								<tbody>
									{taggedList?.map((item, idx) => (
										<tr key={`tag_list_${idx}`}>
											<td className="design-details-column">
												<div className="d-flex align-items-center ">
													{item?.setPackStyleFlag ===
													STATIC_SET_CONSTANTS.SET_PRODUCT ? (
														<div
															className="set-image-layout mr-1"
															style={{ width: '56px' }}
														>
															<img
																src={item?.setImageList[0]}
																alt
																className="cell-img pr-2"
															/>
															<img
																src={item?.setImageList[1]}
																alt
																className="cell-img pr-2"
															/>
														</div>
													) : (
														<img
															src={item?.image}
															alt
															className="cell-img pr-2"
														/>
													)}

													<div className="d-inline-block align-middle ml-2">
														{item?.setPackStyleFlag ===
															STATIC_SET_CONSTANTS.SET_PRODUCT && setTag()}
														{item?.setPackStyleFlag ===
															STATIC_SET_CONSTANTS.PACK_PRODUCT && packTag()}
														<p className="regular-14 gray_dark_01 my-1">
															{item?.referenceNumber}
														</p>
														<ul className="common-list-component mb-2">
															{item?.productGroup && (
																<li>{item?.productGroup}</li>
															)}
															<li>{item?.productSubcategory}</li>
														</ul>
													</div>
												</div>
											</td>
											<td className="date-column">
												<span className="gray_dark_03">{item?.poNumber}</span>
											</td>

											<td className="date-column">
												{item?.isTaggedWithPI ? (
													<span className="red">Already PI created</span>
												) : (
													<img src={`${process.env.PUBLIC_URL}/icons/tick24.svg`} />
												)}
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					</div>
					<div className="modal-footer">
						<div className="footer-buttons text-right">
							<button
								className="button size32 ml-2"
								disabled={isDisabled() || isLoading}
								onClick={onSubmit}
							>
								Submit
							</button>
						</div>
					</div>
				</div>
			</Modal>
		</div>
	);
};

export default CreateNewPi;
